import React from "react"
import { Input } from "antd"
import { useTranslation } from "react-i18next"
import LabeledField from "pagesV2/client/Profile/Tabs/ProfileInfo/LabeledField"
import styles from "../index.module.css"

const { TextArea } = Input

export const TemplateForm = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.questionCard}>
      <LabeledField
        labelKey="settings.template_labels_name"
        name="name"
        rules={[{ required: true, message: t("settings.required_template_name") }]}
      >
        <Input placeholder={t("settings.templates_placeholders_name")} />
      </LabeledField>
      <LabeledField
        labelKey="settings.description"
        name="description"
        rules={[{ required: true, message: t("settings.required_description") }]}
      >
        <TextArea rows={4} placeholder={t("settings.description_placeholder")} />
      </LabeledField>
    </div>
  )
}

TemplateForm.propTypes = {}
